import Vue from 'vue';
import App from './App.vue';
import store from './common/old/store/store.js';
import { router } from './router';
import axios from 'axios';
import './assets/less/resetui.less';
import './assets/less/old/base.less';
import rem from './common/rem'
import config from './config/config';
import common from './common/old/public/common';
import './common/mini.js';
import * as FiltersObj from './common/old/public/filters';

Object.keys(FiltersObj).forEach(key => {
  Vue.filter(key, FiltersObj[key]);
});

// 用rem适配
rem();
Vue.prototype.$common = common;
Vue.prototype.$axios = axios;
Vue.prototype.$config = config;
Vue.config.ignoredElements = ['wx-open-launch-weapp'];
new Vue({
  store,
  router,
  el: '#app',
  render: h => h(App)
});
